import AuthService from "../auth/auth_service";

export default class HistoryService extends AuthService {
  constructor() {
    super("historico");
  }
}
